export default "__VITE_ASSET__$A82J9ZT__"